import { createInteriorRoomCalculator } from "./interior-room-shared.js";

/**
 * Bedroom (Phase 13A). A secondary/general bedroom - see primary-bedroom.ts
 * for the primary bedroom, which gets its own larger closet-system tiers
 * and sitting-area option rather than reusing this file, since a primary
 * bedroom's scope and typical budget are materially different. Bedroom's
 * unique addition is an optional ensuite rough-in (plumbing stubbed for a
 * future ensuite bathroom) - priced here as rough plumbing only, distinct
 * from an actual bathroom build-out.
 */
export const calculateBedroom = createInteriorRoomCalculator({
  projectType: "bedroom",
  anchorItemId: "bedroom_base_renovation",
  tierFeatures: [
    {
      answerKey: "bedroom_flooring_type",
      itemIdByTier: { not_changing: null, basic: "bedroom_flooring_basic", mid_range: "bedroom_flooring_mid", premium: "bedroom_flooring_premium" },
      quantityFromSqft: true,
      excludedMessage: "Flooring is not changing - excluded from this estimate."
    },
    {
      answerKey: "bedroom_painting",
      itemIdByTier: { not_included: null, walls_only: "bedroom_painting_walls", full_room: "bedroom_painting_full" },
      quantityFromSqft: true,
      excludedMessage: "Painting was not included - excluded from this estimate."
    },
    {
      answerKey: "bedroom_trim",
      itemIdByTier: { keep_existing: null, standard_upgrade: "bedroom_trim_standard", premium_millwork: "bedroom_trim_premium" },
      excludedMessage: "Trim/millwork is not being upgraded - excluded from this estimate."
    },
    {
      answerKey: "bedroom_lighting",
      itemIdByTier: { keep_existing: null, standard_swap: "bedroom_lighting_standard", statement_lighting: "bedroom_lighting_statement" },
      excludedMessage: "Lighting is not being upgraded - excluded from this estimate."
    },
    {
      answerKey: "bedroom_built_ins",
      itemIdByTier: { none: null, standard: "bedroom_built_ins_standard", custom: "bedroom_built_ins_custom" },
      excludedMessage: "No closet/storage built-ins were requested - excluded from this estimate."
    },
    {
      answerKey: "bedroom_windows_doors",
      itemIdByTier: { none: null, replace_existing: "bedroom_windows_doors_replace", add_new: "bedroom_windows_doors_add" },
      excludedMessage: "No window or door changes were requested - excluded from this estimate."
    }
  ],
  booleanFeatures: [
    { answerKey: "bedroom_ensuite_rough_in", itemId: "bedroom_ensuite_rough_in", excludedMessage: "No future-ensuite plumbing rough-in was requested - excluded from this estimate." }
  ],
  electricalItemId: "bedroom_electrical",
  demolitionItemId: "bedroom_demolition",
  accessibilityItemId: "bedroom_accessibility",
  permitDesignItemId: "bedroom_permit_design"
});
